var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-container',{attrs:{"fluid":""}},[_c('h4',[_vm._v("Setari sistem")]),_c('b-row',[_c('b-col',{attrs:{"md":"4"}},[_vm._v(" s ")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }